// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r1No","type":"styles_type__2uf7Q","choices":"styles_choices__b9jS3"};